import {registerPlugin} from '@capacitor/core';

export interface ObjectIdListFromIQO {
	struktur: string;
	objId: string;
}

export interface CMIntentOptions {
	intenturi: string | Array<string>;
	targetpath: string;
}
export interface CMIntentResult {
	error?: string;
	objIdList?: Array<ObjectIdListFromIQO>;
	copiedFiles?: Array<any>[];
}
export interface HandleIntentPlugin {
	handleIntent(options: CMIntentOptions): Promise<CMIntentResult>;
}

const cmHandleIntent = registerPlugin<HandleIntentPlugin>('CMHandleIntent');
export default cmHandleIntent;
